import { UserGroups } from "./../../../assets/config/models";
import { Router, RouterModule } from "@angular/router";
import { CoreService } from "./../../services/coreService";
import { AfterViewInit, Component, inject, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { switchMap, tap, debounceTime } from "rxjs/operators";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { TicketDetailsModalComponent } from "../../components/ticket-details-modal/ticket-details-modal.component";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../services/authService";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  providers: [CoreService],
  imports: [CommonModule, FormsModule, RouterModule, MatDialogModule],
  standalone: true,
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public userDetails: any;
  results: object[] = [];
  ticket: any = null;
  loading = false;
  logo: any = environment.logo_path;
  category: any;
  message: any;
  searchTerm$ = new Subject<string>();
  group: any;
  groupTypes = UserGroups;
  dialogRef!: MatDialogRef<any>;
  isPrivateUser: any;

  private readonly coreService: CoreService = inject(CoreService);
  private readonly router: Router = inject(Router);
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly authService: AuthService = inject(AuthService);

  async ngOnInit() {
    const userDetails = localStorage.getItem("user_details");

    if (!userDetails) {
      console.log("No User details set");
      return;
    }
    this.group = JSON.parse(userDetails).group;
    this.userDetails = JSON.parse(userDetails);
    this.isPrivateUser = this.authService.isPrivateUser(this.userDetails);

    this.category = "user";
    this.searchTerm$
      .pipe(
        debounceTime(400),
        tap((result) => {
          this.loading = true;
          console.log(result);
        }),
        switchMap((term) =>
          this.coreService.searchEntries(term, this.category),
        ),
      )
      .subscribe((results: any) => {
        this.results = results;
        setTimeout(() => {
          this.loading = false;
        });
      });
  }

  ngAfterViewInit(): void {
    document.getElementById("nav-button")!.click();
    setTimeout(() => {
      document.getElementById("nav-button")!.click();
    }, 3);
  }

  focusOut() {
    setTimeout(() => {
      this.results.length = 0;
    }, 150);
  }

  showModal(source: any, ticket: any) {
    this.ticket = ticket;
    switch (source) {
      case "ticket": {
        this.dialogRef = this.dialog.open(TicketDetailsModalComponent, {
          data: {
            ticket: this.ticket,
          },
        });
        break;
      }
      default: {
        break;
      }
    }
    this.dialogRef.afterClosed().subscribe((result) => {
      console.log("Result from modal is", result);
      if (result) {
        this.handleModal(source, result);
      }
    });
  }

  handleModal(source: any, event: any) {
    switch (source) {
      case "ticket": {
        break;
      }
      default: {
        break;
      }
    }
  }

  async logout() {
    this.authService.logout();
  }
}
